(function() {
    'use strict';

    angular.module('eclipseApp.myAccount').controller('suspendDeviceModalCtrl',
      ['$rootScope',
        '$scope',
        '$state',
        'httpService',
        'data',
        'uteEndpoint',
        'commonService',
        'uteLocale',
        'lostStolenDeviceService',
        'dtmServiceConstants',
        'dtmService',
        function($rootScope, $scope, $state, httpService, data, uteEndpoint, commonService, uteLocale, lostStolenDeviceService, dtmServiceConstants, dtmService) {

        $scope.ban = data.ban;
        $scope.ctn = data.ctn;
        $scope.suspendProcessing = false;
        $scope.losSuspendError = false;
        $scope.dtmRule = dtmServiceConstants.dtmRules.reportLostDevice;
        angular.forEach(commonService.accountDetails, function(accountDetail, accountDetailKey) {
            if ($scope.ban === accountDetail.accountNumber) {
                angular.forEach(accountDetail.subscriberServices, function(subscriberService) {
                    if (subscriberService.wireless.subscriberNo == $scope.ctn) {
                        $scope.firstName = subscriberService.wireless.firstName ;
                        $scope.lastName = subscriberService.wireless.lastName ;
                    }
                });
            }
        });

        $scope.ok = function() {

            $scope.suspendProcessing = true;
            var promise = httpService.send(
                'v1/wireless/lostorstolen/add', {
                    accountNumber: $scope.ban,
                    ctn: $scope.ctn,
                    accountType: $rootScope.userInfo.profileType.prepaid ? 'prepaid' : 'postpaid' ,
                    customerFirstName: $scope.firstName ,
                    customerLastName: $scope.lastName ,
                    email: lostStolenDeviceService.getContactEmail(),
                    language: uteLocale.language
                });
            promise.then(
                function(result) {
                    if (result.data.error || result.data.status == 'Failed') {
                        $scope.suspendProcessing = false;
                        $scope.losSuspendError = true;

                        var errorMessage = angular.isString(result.data.error) ? result.data.error || $scope.dtmRule.defaultServerError: $scope.dtmRule.defaultServerError;
                        dtmService.fireDtmExceptions($scope.dtmRule.name, [errorMessage], 'SS');
                    } else {
                        angular.forEach(commonService.accountDetails, function(accountDetail, accountDetailKey) {
                            if ($scope.ban === accountDetail.accountNumber) {
                                angular.forEach(accountDetail.subscriberServices, function(subscriberService) {
                                    if (subscriberService.wireless.subscriberNo == $scope.ctn) {
                                        subscriberService.wireless.subscriberStatus = "Suspended";
                                        subscriberService.wireless.reason = "LOS";
                                    }
                                });
                            }
                        });
                        dtmService.complete($scope.dtmRule.name);
                        $state.go("myAccount.lostStolenSuspendDeviceSuccess");
                    }
                },
                function(reason) {
                    $scope.suspendProcessing = false;
                    $scope.losSuspendError = true;

                    var error = reason ? reason.data : null;
                    var errorMessage = angular.isString(error) ? error || $scope.dtmRule.defaultServerError: $scope.dtmRule.defaultServerError;
                    dtmService.fireDtmExceptions($scope.dtmRule.name, [errorMessage], 'SS');
                });
        };

        //FUSS-1800 -fix for cancel on pop up
          $scope.cancel = function(){
        		  angular.forEach(commonService.accountDetails, function(accountDetail, value) {
                  if ($scope.ban === accountDetail.accountNumber) {
              		var lob = accountDetail.LOB ;
              		if(lob.toUpperCase() == "WL"){
                    $state.go('myAccount.wireless' , {'accountNumber':  $scope.ban , 'subscriberNo':   $scope.ctn });
                  }else {
                    $state.go('myAccount.prepaidWLDashboard' , {'accountNumber': $scope.ban, 'subscriberNo':   $scope.ctn });
                  }
              	}
              });
          }
    }]);

})();
